import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyC0_-vAl4qC9NvasbNKxHt_NEUX2ihLqWM',
  authDomain: 'foundermatcha.firebaseapp.com',
  projectId: 'foundermatcha',
  storageBucket: 'foundermatcha.appspot.com',
  messagingSenderId: '888687727548',
  appId: '1:888687727548:web:0e9089edc7ffdee7d091b9',
  measurementId: 'G-WSDGM0BMTV',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Enable Analytics Debug Mode in development
if (process.env.NODE_ENV === 'development') {
  // @ts-ignore
  window['GA_DEBUG'] = true;
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app);

setPersistence(auth, browserLocalPersistence)
  .then(() => {
  })
  .catch((error) => {
  });

export default app;
